import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../../api.types';
import { SendPushNotificationRequest } from './push-notification.types';

export const requestSendPushNotification = createAction<SagaPayload<SendPushNotificationRequest>['payload']>(
  'push-notification/sendNotification'
);
